import { render, staticRenderFns } from "./DocumentosNotasModal.vue?vue&type=template&id=f8d3b960"
import script from "./DocumentosNotasModal.vue?vue&type=script&lang=js"
export * from "./DocumentosNotasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports